import React from "react";
import './MaintenanceScheduled.css';
// This is called from OrderSearchForm compoment
export default function MaintenanceScheduled(props) {
  const scheduledMessage = 'Please be advised STG ePay and STG Customer Portal will be down for scheduled maintenance from approximately 8:00 AM until 1:00 PM EST on May 30th, 2026.';

   return (
    <div id="content" className='container maintenance-scheduled-container'>
  

        <p className="main main-message">
          {scheduledMessage}
        </p>

    </div>
  );
} 
